/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateEquipmentWorkerRequest { 
    workerId?: string | null;
    number: number;
    stratumUrl?: string | null;
    workerName?: string | null;
    password?: string | null;
}

